import * as React from 'react';
import * as _ from 'lodash';
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal, Radio, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { IFollowUpLabOptionsData, IFollowUpLabOptionsValidation } from './follow-up-lab-options-data';
import UploadFile from './upload-file';


interface IProps {
    show: boolean,
    data: IFollowUpLabOptionsData,
    upload: File,
    onFileSelect: (file: File) => void,
    onUploadFile: (followUpId: number) => void,
    onChange: (data: IFollowUpLabOptionsData) => void,
    onSubmit: () => void,
    onCancel: () => void
}



const CenterFollowUpLabOptionsAddEdit = (props: IProps) => {

    const [validation, setValidation] = React.useState<IFollowUpLabOptionsValidation>({
        isFollowUpNeeded: true,
        isLabOrdersOrPrintableLetters: true,
        isOptionText: true
    });

    const [dirty, setDirty] = React.useState(false);


    const handleSelectFile = (file: File) => {
        props.onFileSelect(file);
    }

    const handleChange = (field: string, value: any) => {

        let data = _.cloneDeep(props.data);


        switch (field) {
            case 'isFollowUpNeeded':
                data.isFollowUpNeeded = value;
                break;
            case 'isLabOrdersOrPrintableLetters':
                data.isLabOrdersOrPrintableLetters = value;
                break;
            case 'optionText':
                data.optionText = value;
                break;
            case 'filePath':
                data.filePath = value;
                break;
        }

        props.onChange(data);
    };


    const handleSubmit = () => {

        let { isFollowUpNeeded, isLabOrdersOrPrintableLetters, optionText } = props.data;

        let newValidation = {
            isFollowUpNeeded: isFollowUpNeeded != null,
            isLabOrdersOrPrintableLetters: isLabOrdersOrPrintableLetters != null,
            isOptionText: optionText != ''
        };

        let isValid =
            newValidation.isFollowUpNeeded
            && newValidation.isFollowUpNeeded
            && newValidation.isOptionText;;
      
        setValidation(newValidation);
        setDirty(true);

        if (isValid) {
            props.onSubmit()
        }
    };


    React.useEffect(() => {
        if (props.data == null)
            setValidation({
                isFollowUpNeeded: true,
                isLabOrdersOrPrintableLetters: true,
                isOptionText: true
            });
    }, [props.data])



    if (props.data == null)
        return null;

    const { optionText } = props.data;
    const title = props.data.id == 0 ? 'Add Center Follow Up Lab Option' : 'Edit Center Follow Up Lab Option';
    const saveButtonTitle = 'Save';
    const disableFormControl = props.upload == null;
    const disableFormUpload = props.data.isLabOrdersOrPrintableLetters;


    return (
        <>
            <Modal bsSize='lg' backdrop='static' show={props.show} onHide={props.onCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form horizontal>
                        <FormGroup validationState={dirty && validation.isOptionText == false ? 'error' : null} style={{ paddingBottom: 0 }}>
                            <Col xs={6} lg={6} componentClass={ControlLabel} style={{ textAlign: 'left' }}>Question Donor will see:<br/>
                                <span style={{fontWeight:'normal'}}>"How would you like to complete your follow-up labs?"</span>
                            </Col>  
                            <Col xs={6} lg={6} componentClass={ControlLabel} style={{ textAlign: 'left' }}>
                                <span>Answer they will click for this option:</span><br />
                                <FormControl
                                    style={{ fontWeight: 'normal' }}
                                    value={optionText}
                                    onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => handleChange('optionText', e.currentTarget.value)}
                                    maxLength={50}
                                    placeholder="e.g. Go to Quest"
                                />
                            </Col>
                        </FormGroup>

          
                        <FormGroup style={{paddingTop:20}}>
                            <Col xs={6} lg={6} componentClass={ControlLabel} style={{ textAlign: 'left' }}>Do we need to trigger Follow-Up when selected (put in To-Do)?:</Col>
                            <Col xs={6} lg={6}>
                                <Radio inline name='isFollowUpNeeded' value={1} checked={props.data.isFollowUpNeeded} onChange={() => handleChange('isFollowUpNeeded', true)}>Yes</Radio>
                                <Radio inline name='isFollowUpNeeded' value={0} checked={!props.data.isFollowUpNeeded} onChange={() => handleChange('isFollowUpNeeded', false)}>No</Radio>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={6} lg={6} componentClass={ControlLabel} style={{ textAlign: 'left' }}>Does this option include lab orders or printable letter?:</Col>
                            <Col xs={6} lg={6}>
                                <Radio inline name='isLabOrdersOrPrintableLetters' value={1} checked={props.data.isLabOrdersOrPrintableLetters} onChange={() => handleChange('isLabOrdersOrPrintableLetters', true)}>Yes</Radio>
                                <Radio inline name='isLabOrdersOrPrintableLetters' value={0} checked={!props.data.isLabOrdersOrPrintableLetters} onChange={() => handleChange('isLabOrdersOrPrintableLetters', false)}>No</Radio>
                            </Col>
                        </FormGroup>

              
                    {disableFormUpload &&
                        (<>
                        <FormGroup>
                            <Col xs={6} lg={6} componentClass={ControlLabel} style={{ textAlign: 'left' }}>Upload Lab Orders/Letter:</Col>
                            <Col xs={6} lg={4}>
                                <UploadFile
                                    elementName="FollowUp"
                                    valid={true}
                                    disable={false}
                                    onSelectFile={handleSelectFile}
                                />
                                {props.upload != null && (
                                    <div style={{ marginTop: 5 }}>Selected File: {props.upload.name}</div>
                                )}
                            </Col>          
                            </FormGroup>
                               
                        <FormGroup>
                            <Col xs={1} lg={1} componentClass={ControlLabel}></Col>
                            <Col xs={10} lg={10} componentClass={ControlLabel} style={{ backgroundColor: "#f9cb9c", textAlign: "left" }}>After uploading file, please make sure to preview the file to ensure that any of form fields will be correctly populated with the donor's information</Col>
                            <Col xs={1} lg={1} componentClass={ControlLabel}></Col>
                        </FormGroup>
                     </>)}

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' disabled={props.data.id == 0 ? (disableFormControl && disableFormUpload) : false}  onClick={handleSubmit}>{saveButtonTitle}</Button>
                    <Button onClick={props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CenterFollowUpLabOptionsAddEdit;